<template>
    <v-container fluid>
        <Overlay />
        <v-row
            align="center"
            justify="center"
        >
            <v-col
                cols="12"
                lg="8"
                class="d-flex flex-row justify-space-between align-center"
            >
                <h1>Edit Card</h1>
                <v-btn to="/card/create">
                    <v-icon
                        left
                        small
                    >
                        fas fa-plus-circle
                    </v-icon>
                    Add Card
                </v-btn>
            </v-col>
        </v-row>

        <v-row
            align="start"
            justify="center"
            class="d-flex flex-row justify-center"
        >
            <v-col
                cols="12"
                md="5"
                align="center"
                justify="center"
            >
                <CardEditForm />
            </v-col>
            <v-col
                cols="12"
                md="3"
            >
                <CardStructure />
            </v-col>
        </v-row>
        <v-dialog
            v-model="deleteModal"
            width="500"
        >
            <v-card>
                <v-card-title>
                    <v-icon left>
                        fas fa-exclamation-triangle
                    </v-icon>Delete Card: {{ name }}
                </v-card-title>

                <v-card-text>
                    <p>Deleting this card is permanent and cannot be undone.</p>
                    <p>Click "Delete Card" to proceed.</p>
                </v-card-text>

                <v-divider />

                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        text
                        @click="toggleDeleteModal(false)"
                    >
                        Cancel
                    </v-btn>
                    <v-btn
                        color="primary"
                        @click="destroy()"
                    >
                        Delete Card
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import CardEditForm from './CardEditForm';
import Overlay from '../../../../components/Overlay';
import { mapActions, mapMutations, mapState } from 'vuex';
import CardStructure from './CardStructure';

export default {
    components: { CardStructure, Overlay, CardEditForm },

    computed: {
        ...mapState('cardEditor', ['name', 'cardId', 'deleteModal', 'sections'])
    },

    mounted() {
        this.getData();
    },

    methods: {
        ...mapMutations({
            toggleDeleteModal: 'cardEditor/toggleDeleteModal'
        }),

        ...mapActions({
            showNotification: 'notification/show',
            getData: 'cardEditor/getData',
            saveData: 'cardEditor/saveData',
            destroyData: 'cardEditor/destroyData'
        }),

        destroy() {
            this.toggleDeleteModal(false);
            this.destroyData();
        }
    }
};
</script>

